export const CONCILIATION_CATEGORIES = {
  CONCILIACAO: "CONCILIACAO",
  RELATORIOS: "Relatórios",
  DTEF: "DTEF",
  ADMINISTRATIVO: "Administrativo",
} as const;
